"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_TYPES = void 0;
/* ---------------------------------- consts -------------------------------- */
exports.USER_TYPES = ['ecocart_admin', 'merchant_admin', 'api_admin'];
